export default __webpack_public_path__ + "static/media/lightning.a5a3ab27.jpg";